"use strict";

exports.__esModule = true;
exports.ChartWrapper = exports.ChartTitle = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ChartWrapper = exports.ChartWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ChartWrapper",
  componentId: "sc-yyiobb-0"
})(["flex:1 1 auto;position:relative;width:100%;"]);
var ChartTitle = exports.ChartTitle = _styledComponents["default"].h1.withConfig({
  displayName: "styles__ChartTitle",
  componentId: "sc-yyiobb-1"
})(["width:100%;text-align:center;"]);